import { ProfileType } from '@/shared/generated/sdk';
import { useProfileStore } from '@/shared/store/profile.store';

export const useIsFounder = () => {
  const { profileType } = useProfileStore();

  return profileType === ProfileType.MainUser;
};
